import {
  message,
  PageHeader,
  Spin,
  Space,
  Tabs,
  Select,
} from "antd";

import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  Form,
  ButtonItem,
  ErrorItem,
  FormItem,
  SelectItem
} from "../../../../Components/Items";
import { FilePdfOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import buildReporteTaxidermiaPdfMake from "../../../../Pdf/reporteTaxidermiaPdf";

const { Option } = Select;

moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { TabPane } = Tabs;

// Ancla de un mes: su día 1, como fecha-día "YYYY-MM-DD". Se manda así —y no como
// instante ISO— para que el backend la ancle al mediodía con parsearFechaDia y el día 1
// no se corra al mes anterior leído desde otra zona horaria.
const anclaMes = (mesMoment) => mesMoment.clone().startOf("month").format("YYYY-MM-DD");

// Mes al que pertenece "hoy", para preseleccionar el filtro
const mesActualValue = () => anclaMes(moment());

// Lista de los últimos 12 meses, más reciente primero
const generarOpcionesMes = () => {
  const opciones = [];
  let cursor = moment().startOf("month");
  for (let i = 0; i < 12; i++) {
    opciones.push({
      label: cursor.format("MMMM YYYY"),
      value: anclaMes(cursor),
    });
    cursor = cursor.clone().subtract(1, "month");
  }
  return opciones;
};
class ReporteTaxidermia extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    dataReporte: null,
  };


  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    const fechaReporte = mesActualValue();
    this.formRef.current.setFieldsValue({ fechaReporte });
    this.consultarReporteTaxidermia({ fechaReporte });
  }

  consultarReporteTaxidermia(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesTaxidermia/reporteTaxidermia",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const docDefinition = buildReporteTaxidermiaPdfMake(res.data);
          const pdf = pdfMake.createPdf(docDefinition);

          this.setState({ loading: false, dataReporte: res.data }, () => {
            pdf.open({}, window.frames["reporteTaxidermiaPdf"]);
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      });

  }

  descargarPdf() {
    if (!this.state.dataReporte) return;

    pdfMake
      .createPdf(buildReporteTaxidermiaPdfMake(this.state.dataReporte))
      .download(`Reporte_Taxidermia_${moment().locale("es").format("L")}`);
  }


  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteTaxidermia"
          onFinish={this.consultarReporteTaxidermia.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte de Taxidermia"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                marginBottom: 20,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="3" key="3" forceRender tab="Mes">
                  <FormItem
                    initialValue={mesActualValue()}
                    name="fechaReporte"
                    required
                    noStyle
                  >
                    <SelectItem
                      placeholder="Selecciona el mes"
                      style={{ width: 260 }}
                    >
                      {generarOpcionesMes().map((op) => (
                        <Option key={op.value} value={op.value}>
                          {op.label}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>

                  <div style={{ marginTop: 6 }}>
                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                      Seleccione el mes que desea consultar. El reporte se generará
                      considerando del día 1 al último día del mes elegido.
                    </span>
                  </div>

                </TabPane>
              </Tabs>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 10,
                  marginBottom: 20,
                }}
              >
                <div
                  style={{
                    width: "85%",
                    maxWidth: 1100,
                    height: "75vh",
                    border: "1px solid rgb(235, 237, 240)",
                    borderRadius: 8,
                    overflow: "hidden",
                    backgroundColor: "white",
                  }}
                >
                  <iframe
                    title="Reporte Taxidermia"
                    id="reporteTaxidermiaPdf"
                    name="reporteTaxidermiaPdf"
                    style={{ width: "100%", height: "100%", border: "none" }}
                  />
                </div>
              </div>
            </div>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteTaxidermia);
